import { useContext } from 'react';

import VehicleImageView from 'components/shared/VehicleImageView';

import VehicleDetailsTable from '../components/VehicleCardDetailsTable';
import VehicleCardNotes from '../components/VehicleCardNotes';
import VehicleCardYearMakeModel from '../components/VehicleCardYearMakeModel';
import { VehicleCardContext } from '../VehicleCard';
import VendorTasks from './VendorTasks';

import './VehicleCardVendorDesktop.scss';

const VehicleCardVendor = () => {
  const { vehicle } = useContext(VehicleCardContext);
  const vehicleId = vehicle?.vehicleCard.id;

  return (
    <div className="VehicleCardVendor">
      <div className="VehicleCardVendor-details">
        <div className="VehicleCardVendor-vehicleInfo">
          <VehicleImageView
            thumbnail
            imageUrl={vehicle?.vehicleCard.vehicleImage}
            skeleton={!vehicle}
          />
          <VehicleCardYearMakeModel />
        </div>

        <VehicleDetailsTable showVin={false} />
      </div>

      <div className="border-right" />
      <VendorTasks vehicle={vehicle!} />
      <div className="border-right" />
      <VehicleCardNotes notes={vehicle?.notesByDate!} vehicleId={vehicleId!} />
    </div>
  );
};

export default VehicleCardVendor;
